import React from 'react';
import classNames from 'classnames';
import { onKeyDownHandler } from 'helpers/ui.helper';
import { ELSIcon } from '..';
var CollapsePanel = function (props) {
    var labelKey = props.labelKey, header = props.header, children = props.children, _a = props.isCollapse, isCollapse = _a === void 0 ? true : _a, onClickItem = props.onClickItem, showArrow = props.showArrow, collapseIconName = props.collapseIconName, expandIconName = props.expandIconName;
    var contentClassName = classNames('c-els-accordion__body', {
        'c-collapse__panel--collapsed': isCollapse,
        'c-collapse__panel--expanded': !isCollapse
    });
    var renderIcon = isCollapse ? (<ELSIcon name={collapseIconName} size="1x" customClass="c-collapse__panel-header-icon"/>) : (<ELSIcon name={expandIconName} size="1x" customClass="c-collapse__panel-header-icon"/>);
    var onClickHandler = function () { return onClickItem(labelKey); };
    return (<li key={labelKey} className="c-els-accordion__group c-els-accordion__group--expanded c-collapse__panel">
      <div id={"accordion-button-".concat(labelKey)} className="c-collapse__panel-header" onClick={onClickHandler} onKeyDown={function (evt) { return onKeyDownHandler(evt, onClickHandler); }} role="button" tabIndex={0} aria-expanded={!isCollapse} aria-controls={"accordion-panel-".concat(labelKey)}>
        <span aria-hidden="true" className="c-collapse__panel-header-button">
          {showArrow && renderIcon}
        </span>
        <span className="c-els-accordion__button-text c-collapse__panel-header-text">{header}</span>
      </div>

      <div className={contentClassName} id={"accordion-panel-".concat(labelKey)} aria-labelledby={"accordion-button-".concat(labelKey)}>
        <div className="c-els-accordion__body-content">{children}</div>
      </div>
    </li>);
};
export default CollapsePanel;
